<template>
    <div class="header__al">
        <div class="header__left">
            <!-- <span class="helper__tooltip v4">
                <span
                    v-html="t.dash_business_tooltip_pv_points"
                    class="helper__tooltip--text"
                ></span>
            </span> -->
            <img src="/internacional/public/office3/img/franchise/ic-trophy.svg">
            <div>
                <!-- <small v-html="t.you_are_qualified_as"></small> -->
                <h2 v-html="t.start_ranking"></h2>
                <!-- <h2 v-html="t.affiliate_level+' '+userLevel"></h2> -->
                <!-- <h3>{{ userPoints }} Pts</h3> -->
            </div>
            <div class="progress-bar" v-if="userLevel < 4">
                <div class="bar" v-bind:style="{ width: progressBarPointsStep + '%' }"></div>
            </div>
        </div>
        <div class="header__right">
            <div>
                <div v-if="allData.receive_message_sponsored" class="sponsor" data-toggle="modal" data-target="#send-message-upline-sponsored">
                    {{t.your_sponsor_is}} <span><b>{{allData.infos_parent_user.nome}}</b></span>
                </div>
                <div class="identity">
                    {{t.your_id_is}} <span> {{allData.dados_usuario_office.id}} </span>
                </div>
            </div>
            <div class="afiliate__link">
                <label v-html="t.your_main_link_is"></label> 
                <div>
                    <input
                        type="text"
                        :value="allData.ba_share_url+allData.dados_usuario_office.id"
                        id="general-link"
                        class="general-input link"
                        readonly="readonly"
                    >
                    <a 
                        data-clipboard-target="#general-link" 
                        data-labelcopy="copied" 
                        class="copy button3 large">
                        {{ t.label_copiar }}
                    </a>
                </div>
            </div>
            <br>
            <br>
            <div class="afiliate__link" v-if="allData.url_franchisee_plan_info.isAllowed && allData.url_franchisee_plan_info.isFranchiseeBA">
                <label>{{t.label_link_franchisee_plan}}</label> 
                <div>
                    <input
                        type="text"
                        :value="allData.url_franchisee_plan_info.linkFranchiseePlan + '#aid=' + allData.dados_usuario_office.id"
                        id="general-link-franchisee-plan"
                        class="general-input link"
                        readonly="readonly"
                    >
                    <a 
                        data-clipboard-target="#general-link-franchisee-plan" 
                        data-labelcopy="copied" 
                        class="copy button3 large">
                        {{ t.label_copiar }}
                    </a>
                </div>
            </div>
                
        </div>
    </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
    name: "affiliate-link-v4",
    props: ["translation"],
    data() {
        return {
            t: this.$parent.view.translation.affiliate_link,
            allData: this.$parent.view,
            levelSteps: [0, 180, 347, 485], //level 1, 180 points...

            userLevel: this.$parent.view.dashboard_values_v3.header_level,
            userPoints: this.$parent.view.dashboard_values_v3.all_values.business_pv_poins,
        };
    },
    mounted() {
        if(this.userLevel == 0 ||
           this.userLevel == null) this.userLevel = this.t.bronze;
        if(this.userLevel == 1)    this.userLevel = this.t.silver;
        if(this.userLevel == 2)    this.userLevel = this.t.gold;
        if(this.userLevel == 3)    this.userLevel = this.t.platinum;
        
    }, 

    computed: {
        progressBarPointsStep: function() {
            if (this.userLevel == 4) return;
            return Math.round(Number(this.userPoints) * 100 / this.levelSteps[Number(this.userLevel)+1])
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header__al {

    display: grid;
    grid-template-columns: 45% 55%;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 8px;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
    }

    .header__left {
        padding: 2rem 1rem;
        background: var(--theme-color-primary);
        text-align: center;
        color: #fff;
        border-radius: 4px 0px 0px 4px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        .helper__tooltip {
            position: absolute;
            right: 48px;
            top: 11px;
            &::after {
                background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19 2H5C3.89 2 3 2.9 3 4V18C3 19.1 3.89 20 5 20H9L12 23L15 20H19C20.1 20 21 19.1 21 18V4C21 2.9 20.1 2 19 2ZM13 18H11V16H13V18ZM15.07 10.25L14.17 11.17C13.45 11.9 13 12.5 13 14H11V13.5C11 12.4 11.45 11.4 12.17 10.67L13.41 9.41C13.78 9.05 14 8.55 14 8C14 6.9 13.1 6 12 6C10.9 6 10 6.9 10 8H8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8C16 8.88 15.64 9.68 15.07 10.25Z' fill='white'/%3E%3C/svg%3E%0A");
            }
            .helper__tooltip--text {
                left: 35px;
                min-width: 200px;
                @media (max-width: 993px) {
                    left: unset;
                    right: -34px;
                }
            }
        }

        img {
            margin-bottom: 1rem;
        }
        h2 {
            margin: 0.4rem 0rem 1.2rem 0rem;
            text-transform: uppercase;
        }
        small, h2 {
            font-weight: bold;
        }

        .progress-bar {
            background: #E5E5E5;
            border-radius: 100px;
            height: 9px;
            position: relative;
            width: 246px;
            .bar {
                position: absolute;
                background: #FFFA8D;
                border-radius: 100px;
                height: 9px;
            }
        }

    }

    .header__right {
        padding: 1.5rem 3rem 2rem 3rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 190px;

        @media (max-width: 768px) {
           padding: 1.5rem
        }

        .sponsor, .identity {
            color: #000;
            text-align: right;
            font-weight: bold;
            line-height: 2.5rem;
            span {
                color: var(--theme-color-accent);
            }
        }
        .sponsor {
            cursor: pointer;
        }
        .afiliate__link > div {
            display: flex;

            @media (max-width: 368px) {
                flex-direction: column;
            }

            input {
                flex: 1;
                border: 1px solid #DADADA;
                border-radius: 4px 0px 0px 4px;
                padding: 9px 1rem;
                color: var(--theme-color-primary);
                font-weight: bold;
            }
            a {
                background: var(--theme-color-accent);
                font-size: 1.1rem;
                text-transform: uppercase;
                font-weight: bold;
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/affiliateLink.vue